import React from "react";
import Select from "component/atom/forms/select/select/Select";
import Modal from "component/hoc/modal/Modal";
import { useFormik } from "formik";
import { roleEndpoints } from "hooks/endpoints";
import { useFetch } from "hooks/useFetch";
import * as Yup from "yup";
import { usePost } from "hooks/usePost";

const Form = ({ formik, options }) => {
  return (
    <form autoComplete='off' onSubmit={formik.handleSubmit}>
      <Select
        label='Role Name'
        placeholder='Select new role'
        options={options}
        name='role'
        value={formik.values.role}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.role}
        touched={formik.touched.role}
      />
    </form>
  );
};

const NewRole = ({ isOpen, onClose, selectedItems, setRefetch }) => {
  const { data: roles, isFetching: isFetchingRoles } = useFetch(
    ["getRoles"],
    roleEndpoints?.getRoles()
  );
  const { mutate: changeRole, isPending } = usePost({
    onSuccessToast: "Updated Successfully",
    toastType: "update",
  });

  const rolesOptions = roles?.data?.map((val) => ({
    value: val.roleId,
    label: val.roleName,
  }));

  const validationSchema = Yup.object({
    role: Yup.string().required("Role is Required"),
  });
  const formik = useFormik({
    initialValues: {
      role: "",
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      const valuesToSend = selectedItems?.map((item) => {
        return { userId: item, roleId: values.role };
      });
      changeRole(
        {
          url: roleEndpoints.updateUserRole(),
          data: valuesToSend,
          method: "Put",
        },
        {
          onSuccess: () => {
            resetForm();
            setRefetch((prev) => !prev);
            onClose();
          },
        }
      );
    },
    enableReinitialize: true,
  });

  return (
    <div>
      <Modal
        title='New Role'
        isOpen={isOpen}
        onClose={onClose}
        modalContent={{
          component: <Form formik={formik} options={rolesOptions} />,
        }}
        onSubmit={formik.handleSubmit}
        buttonType='submit'
        isLoading={isPending}
        onSubmitstyles={{
          onSubmit: {
            label: "Save",
            type: "save",
            opicBAckground: true,
          },
        }}
      />
    </div>
  );
};

export default NewRole;
